import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";
import { leaguesTableCol } from "../../../shared";

export const teamAndManagerCol = style([
  leaguesTableCol,
  {
    width: 140,
    "@media": {
      [`screen and (min-width: ${breakpoints[1]})`]: {
        width: 200,
      },
    },
  },
]);

export const rankCell = style({
  display: "inline-flex",
  alignItems: "center",
  gap: vars.space["2xs"],
});
